export default {
  onPost(req) {

    return([
      200,
      {
        results: window.sampleTaskList
      }
    ]);
  }
}
